<template>
  <div>
    <report-summary
      :cases="cases"
      :title="title"
      :reportDistrict="reportDistrict"
      :reportDate="reportDate"
      :formName="formName"
      :appendixNumber="appendixNumber"
      :reportHeader="reportHeader"
      v-if="userRole && userRole.includes('JKR')"
    />
    <report-summary-dasar-jati
      v-else
      :title="title"
      :reportDistrict="reportDistrict"
      :reportDate="reportDate"
      :formName="formName"
      :appendixNumber="appendixNumber"
      :reportHeader="reportHeader"
    />
    <div
      class="report-viewer page-break"
      v-for="(page, index) in pages"
      :key="`page${index}`"
    >
      <div class="report-viewer-content">
        <div class="table-responsive">
          <table class="table table-sm table-bordered mb-0 h-100">
            <thead>
              <tr>
                <th rowspan="5" style="width: 16.66%" class="text-center">
                  <img src="@/assets/jkr.jpg" class="w-100" loading="lazy" />
                  <p class="mb-0 mt-2">JKR MALAYSIA</p>
                </th>
                <th
                  rowspan="5"
                  style="width: 33.33%"
                  class="text-center text-wrap"
                  colspan="2"
                >
                  PROSEDUR PENYELIAAN KERJA RUTIN
                </th>
                <td style="width: 16.66%">No. Rujukan Dokumen</td>
                <td
                  style="width: 33.33%"
                  class="text-center align-middle"
                  colspan="2"
                >
                  JKR.PK(SJ).P. 01
                </td>
              </tr>
              <tr>
                <td style="width: 16.66%">No. Keluaran</td>
                <td style="width: 33.33%" class="text-center" colspan="2"></td>
              </tr>
              <tr>
                <td style="width: 16.66%">No. Pindaan</td>
                <td style="width: 33.33%" class="text-center" colspan="2"></td>
              </tr>
              <tr>
                <td style="width: 16.66%">Tarikh</td>
                <td style="width: 33.33%" class="text-center" colspan="2">
                  {{ reportDate }}
                </td>
              </tr>
              <tr>
                <td style="width: 16.66%">Muka Surat</td>
                <td style="width: 33.33%" class="text-center" colspan="2">
                  {{ `${index + 1}/${pages.length}` }}
                </td>
              </tr>
              <tr>
                <th
                  colspan="3"
                  style="width: 50%"
                  class="border-transparent-right border-transparent-bottom"
                >
                  [{{ reportFormName }}]
                </th>
                <th
                  colspan="3"
                  style="width: 50%"
                  class="text-right border-transparent-bottom"
                >
                  LAMPIRAN {{ appendixNumber }}
                </th>
              </tr>
              <tr v-if="reportHeader">
                <th
                  colspan="6"
                  class="h6 py-0 font-weight-bold text-center border-transparent-top border-transparent-bottom"
                >
                  {{ reportHeader }}
                </th>
              </tr>
              <tr>
                <th
                  colspan="6"
                  class="text-center border-transparent-top text-uppercase"
                >
                  LAPORAN BERGAMBAR KERJA PENYENGGARAAN RUTIN
                  <div>
                    <span v-if="title">
                      {{ title }}
                    </span>
                    <span v-else>
                      DAERAH {{ reportDistrict.name }}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-uppercase">NEGERI</td>
                <td class="text-uppercase" colspan="2">{{ state }}</td>
                <td class="text-uppercase">DAERAH</td>
                <td class="text-uppercase" colspan="2">
                  {{ reportDistrict.name }}
                </td>
              </tr>

              <template v-for="(p, pageIndex) in page">
                <tr :key="`${pageIndex}-info`">
                  <template v-for="c in p">
                    <td :key="`${c._id}-title`">NAMA JALAN</td>
                    <td
                      :key="`${c._id}-text`"
                      class="text-uppercase"
                      colspan="2"
                    >
                      {{ c.road ? c.road.name : "" }}
                    </td>
                  </template>
                </tr>
                <tr :key="`${pageIndex}-section`">
                  <template v-for="c in p">
                    <td :key="`${c._id}-title`" style="width: 16.66%">
                      SEKSYEN
                    </td>
                    <td :key="`${c._id}-text`" style="width: 16.66%">
                      {{
                        c.lat && c.lng ? formatCoordinate([c.lat, c.lng]) : ""
                      }}
                    </td>
                    <td
                      style="width: 16.66%"
                      :key="`${c._id}-caseNo`"
                      class="text-center bg-secondary"
                    >
                      <span class="text-monospace" v-if="c.caseNumber">
                        #{{ c.caseNumber }}
                      </span>
                    </td>
                  </template>
                </tr>
                <tr :key="`${pageIndex}-caption`">
                  <template v-for="c in p">
                    <td :key="`${c._id}-title`">KEROSAKAN</td>
                    <td :key="`${c._id}-text`" colspan="2">
                      {{ c.caption }}
                    </td>
                  </template>
                </tr>
                <tr
                  :key="`${pageIndex}-image`"
                  class="report-case-image has-caption"
                >
                  <template v-for="c in p">
                    <td :key="`${c._id}-1`" colspan="3" style="width: 50%">
                      <div
                        class="mx-auto position-relative"
                        style="width: fit-content"
                      >
                        <img
                          :src="c.imageUrl"
                          v-if="c.imageUrl && c.imageLoaded"
                        />
                        <div
                          class="report-image-overlay"
                          v-if="c.imageUrl && c.imageLoaded"
                        >
                          <!-- <div
                            class="overlay-map bg-light"
                            :style="{
                              backgroundImage: `url(${getMapSnapshot(c)})`,
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: 'cover',
                            }"
                          > -->
                          <!-- <img :src="getMapSnapshot(c)" /> -->
                          <!-- </div> -->
                          <div class="overlay-content">
                            <p class="mb-0">
                              {{ reportDistrict.name }}, Selangor, Malaysia
                            </p>
                            <p class="small mb-1">
                              {{ c.road ? c.road.name : "" }}
                            </p>
                            <p class="mb-0">
                              Lat {{ formatCoordinate([c.lat]) }}, Lng
                              {{ formatCoordinate([c.lng]) }}
                            </p>
                            <p class="mb-0">
                              {{ formatDate(c.timestamp, "DD/MM/YY hh:mm A") }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Helper from "@/helper";
import ReportSummaryDasarJati from "@/components/report-templates/SummaryDasarJati";
import ReportSummary from "@/components/report-templates/Summary";

export default {
  name: "report-template-kuala-selangor",
  props: [
    "cases",
    "title",
    "reportType",
    "district",
    "header",
    "formName",
    "dateRange",
    "userRole",
  ],
  components: {
    ReportSummary,
    ReportSummaryDasarJati,
  },
  data() {
    return {
      pages: [],
      state: "SELANGOR",
      reportDistrict: "",
      reportHeader: "",
      reportFormName: "",
      reportDate: moment().format("DD MMM YYYY"),
    };
  },
  computed: {
    appendixNumber() {
      if (this.reportFormName) {
        const formName = this.reportFormName.split("-");
        return formName[formName.length - 1];
      } else {
        return "";
      }
    },
  },
  watch: {
    cases: {
      handler() {
        this.$emit("reportLoaded", false);

        this.reportDistrict = this.district;
        this.reportHeader = this.header;
        this.reportFormName = this.formName;

        if (this.cases.length > 0) {
          this.pages = [];

          let cases = [];

          if (this.cases.length > 0) {
            JSON.parse(JSON.stringify(this.cases)).forEach((c) => {
              c.imageUrl =
                c.media && c.media.length > 0
                  ? c.media[c.media.length - 1].url
                  : null;

              c.imageLoaded = false;

              if (
                cases[cases.length - 1] &&
                cases[cases.length - 1].length < 2
              ) {
                cases[cases.length - 1].push(c);
              } else {
                cases.push([c]);
              }
            });

            cases.forEach((c) => {
              if (
                this.pages[this.pages.length - 1] &&
                this.pages[this.pages.length - 1].length < 3
              ) {
                this.pages[this.pages.length - 1].push(c);
              } else {
                this.pages.push([c]);
              }
            });

            let lastPage = this.pages[this.pages.length - 1];

            let lastGroupInLastPage = lastPage[lastPage.length - 1];

            if (lastGroupInLastPage.length < 2) {
              lastGroupInLastPage.push({ _id: "lastInGroup" });
            }

            if (lastPage.length < 3) {
              for (let index = 0; index < 4 - lastPage.length; index++) {
                lastPage.push([{ _id: "lastPage1" }, { _id: "lastPage2" }]);
              }
            }
          }

          this.$nextTick(() => {
            let reportContainer = document.getElementById("reportContainer");

            if (reportContainer) {
              reportContainer.scrollTop = 0;
            }

            this.loadCasesImage();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    loadCasesImage() {
      const currentPage = this.pages.find((page) =>
        page.some((cell) => cell.some((_case) => !_case.imageLoaded))
      );

      const currentPageIndex = this.pages.findIndex((page) =>
        page.some((cell) => cell.some((_case) => !_case.imageLoaded))
      );

      if (currentPage) {
        this.$emit(
          "processingDone",
          true,
          `Loading page [${currentPageIndex + 1} / ${this.pages.length}]`
        );

        currentPage.forEach((page) => {
          page.forEach((_case) => {
            _case.imageLoaded = true;
          });
        });

        this.$nextTick(() => {
          setTimeout(() => {
            this.loadCasesImage();
          }, 500);
        });
      } else {
        this.$emit("reportLoaded", true);

        this.$emit("processingDone", false);

        return;
      }
    },
    formatCoordinate(coord) {
      return Helper.formatCoordinate(coord);
    },
    formatDate(date, format) {
      if (date) {
        return moment(date).format(format);
      } else {
        return "";
      }
    },
    // getMapSnapshot(item) {
    //   return `https://maps.googleapis.com/maps/api/staticmap?center=${item.lat},${item.lng}&zoom=15&size=100x70&maptype=roadmap&markers=color:red|size:tiny|${item.lat},${item.lng}&key=AIzaSyDbMnhEyq2lAIVP52IgNw7SHAcMuPglupc`;
    // },
  },
};
</script>